import axios from "axios";
import { API_BASE_URL, DEFAULT_TIMEOUT } from "../Utils/constants";

const api = axios.create({
  baseURL: API_BASE_URL, // Replace with your API base URL
  timeout: DEFAULT_TIMEOUT || 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error("Unauthorized! Please log in again.");
    }
    return Promise.reject(error);
  }
);

export default api;
